var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H12C13.1046 0 14 0.89543 14 2V17.1384C14 17.5223 13.5853 17.763 13.2519 17.5725L7.9923 14.567C7.3774 14.2157 6.6226 14.2157 6.0077 14.567L0.74807 17.5725C0.41474 17.763 0 17.5223 0 17.1384V2C0 0.89543 0.89543 0 2 0Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkBlue);
export default __webpack_public_path__ + "static/media/bookmark_blue.c29ca531340b7359e0f95ef13ecb3039.svg";
export { ForwardRef as ReactComponent };